import axiosInstance from '../../Helpers/api_helper';

export interface UserDocumentData {
  highestLevelEducation?: string;
  institutionName?: string;
  jobTitle?: string;
  workExperience?: string;
  cvResume?: File | undefined;
  [key: string]: string | File | undefined; // Index signature allowing any string key including File
}

export const userDocumentUpload = async (documentData: UserDocumentData): Promise<any> => {
    try {
      const formData = new FormData();
      for (const key in documentData) {
        if (Object.prototype.hasOwnProperty.call(documentData, key)) {
          if (key === 'cvResume' && documentData[key]) {
            formData.append(key, documentData[key] as File);
          } else {
            formData.append(key, String(documentData[key]));
          }
        }
      }
  
      const response = await axiosInstance.patch(
        'api/v1/participants/userDocumentUpdate',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      console.log("Response:", response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error uploading user document:', error.message);
      throw error;
    }
  };
  